import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import ClearAllIcon from "@mui/icons-material/ClearAll";
import Box from "@mui/material/Box";

const SearchNav = () => {
  return (
    <>
      <Box sx={{ backgroundColor: "#11163A", padding: "0.3rem" }}>
        <Paper
          component="form"
          sx={{
            p: "2px 4px",
            display: "flex",
            alignItems: "center",
            width: "28rem",
            margin: "0rem auto",
          }}
        >
          <IconButton type="submit" sx={{ p: "8px" }} aria-label="search">
            <SearchIcon />
          </IconButton>
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Search for Anything"
            inputProps={{ "aria-label": "Search for Anything" }}
          />
          <Divider
            sx={{ height: "1.75rem", m: "0.031rem" }}
            orientation="vertical"
          />
          <IconButton
            color="error"
            sx={{ p: "0.5rem" }}
            aria-label="directions"
          >
            <ClearAllIcon />
          </IconButton>
        </Paper>
      </Box>
    </>
  );
};

export default SearchNav;
